export default __webpack_public_path__ + "static/media/Image-15.2694d50c.jpg";